// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ia-page {
    --ia-primary: #0049AA;
    --ia-primary-dark: #003d90;
    --ia-purple: #7c3aed;
    --ia-green: #16a34a;
    --ia-border: #e5e7eb;
    --ia-muted: #6b7280;
    --ia-text: #111827;
    font-family: 'Gilroy', 'Gilroy-Medium', 'Segoe UI', sans-serif;
    padding: 24px;
    color: var(--ia-text);
    letter-spacing: 0.01em;
}

/* ---------- Header ---------- */

.ia-header-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
}

.ia-title-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.ia-title {
    font-size: 22px;
    font-weight: 800;
    margin: 0;
    font-family: 'Gilroy-Bold', 'Gilroy', sans-serif;
    color: var(--ia-primary);
}

.ia-badge-new {
    display: inline-block;
    padding: 2px 10px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.03em;
    color: #fff;
    background: var(--ia-primary);
    border-radius: 999px;
    font-family: 'Gilroy-Bold', 'Gilroy', sans-serif;
}

.ia-subheading {
    color: var(--ia-muted);
    margin: 6px 0 0;
    max-width: 640px;
    font-family: 'Gilroy-Medium', 'Gilroy', sans-serif;
    font-size: 14px;
    line-height: 1.5;
}

.ia-btn {
    padding: 9px 16px;
    border-radius: 999px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 1px solid transparent;
    white-space: nowrap;
    font-family: 'Gilroy-SemiBold', 'Gilroy-Medium', 'Gilroy', sans-serif;
}

.ia-btn-outline {
    background: #fff;
    border-color: var(--ia-primary);
    color: var(--ia-primary);
}

.ia-btn-outline:hover {
    background: #eff6ff;
}

.ia-btn-primary {
    background: var(--ia-primary);
    border-color: var(--ia-primary);
    color: #fff;
}

.ia-btn-primary:hover {
    background: var(--ia-primary-dark);
}

.ia-btn-primary:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.ia-btn-plain {
    background: #fff;
    border-color: var(--ia-border);
    color: var(--ia-text);
}

/* ---------- Popular Formats section ---------- */

.ia-section-header-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-top: 32px;
    flex-wrap: wrap;
}

.ia-section-title {
    font-size: 17px;
    font-weight: 700;
    margin: 0 0 4px;
    font-family: 'Gilroy-Bold', 'Gilroy', sans-serif;
    color: var(--ia-primary);
}

.ia-section-subtext {
    color: var(--ia-muted);
    font-size: 13px;
    margin: 0;
    font-family: 'Gilroy-Medium', 'Gilroy', sans-serif;
}

.ia-section-controls {
    display: flex;
    align-items: center;
    gap: 10px;
}

.ia-filter-select {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 14px;
    border: 1px solid var(--ia-border);
    border-radius: 8px;
    font-size: 13px;
    background: #fff;
    color: var(--ia-text);
}

.ia-info-icon {
    color: var(--ia-muted);
}

/* ---------- Format cards ---------- */

.ia-cards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
    gap: 20px;
    margin-top: 16px;
}

.ia-format-card {
    background: #fff;
    border: 1px solid var(--ia-border);
    border-radius: 12px;
    padding: 20px;
    display: flex;
    flex-direction: column;
}

.ia-format-card-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}

.ia-format-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    margin-bottom: 10px;
}

.ia-format-icon.purple {
    background: #f2eaff;
    color: var(--ia-purple);
}

.ia-format-icon.green {
    background: #e6f6ec;
    color: var(--ia-green);
}

.ia-format-title {
    font-size: 16px;
    font-weight: 700;
    margin: 0;
    font-family: 'Gilroy-Bold', 'Gilroy', sans-serif;
    color: var(--ia-text);
}

.ia-format-tag {
    font-size: 12px;
    font-weight: 600;
    color: var(--ia-primary);
    font-family: 'Gilroy-Medium', 'Gilroy', sans-serif;
}

.ia-format-menu-btn {
    background: none;
    border: none;
    color: var(--ia-muted);
    cursor: pointer;
    font-size: 16px;
    padding: 4px;
}

/* Static poster image on the listing page — the interactive video/gif preview
   only appears once the user opens a format's own configure page. */
.ia-format-preview-img {
    display: block;
    width: 100%;
    height: 320px;
    object-fit: cover;
    object-position: center;
    border-radius: 8px;
    margin-top: 14px;
    background: #f3f4f6;
}

/* ---------- Ad creative preview ---------- */
/* One persistent structure shared by QR Code and Shoppable: a real video/gif fills
   the viewport at all times (never remounted, so playback is continuous), and
   layout "decorations" (QR badge, product panel, side panel) rise/glow in on top
   of it. The video viewport and the side panel are both absolutely positioned and
   share the same --ia-panel-w custom property, so BOTH the expand/collapse (layout
   change) AND the left/right swap (position change) are smooth, continuous
   transitions rather than instant snaps. The video itself always keeps its source
   aspect ratio via object-fit: contain, so resizing it never stretches or crops
   the footage — and on mobile it keeps its native 16:9 shape (instead of being
   stretched to fill the whole portrait screen) so the QR/product decorations stay
   confined to the ad's own height, not the full phone height. */

.ia-video-frame {
    --ia-panel-w: 110px;
    --ia-bottom-h: 105px;
    position: relative;
    margin-top: 14px;
    aspect-ratio: 16 / 9;
    border-radius: 8px;
    background: linear-gradient(160deg, #1f2937, #0f172a);
    overflow: hidden;
    color: #fff;
}

.ia-video-viewport {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    transition: left 0.5s cubic-bezier(0.16, 1, 0.3, 1), width 0.5s cubic-bezier(0.16, 1, 0.3, 1),
        height 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

.ia-video-frame.panel-right .ia-video-viewport {
    left: 0;
    width: calc(100% - var(--ia-panel-w));
}

.ia-video-frame.panel-left .ia-video-viewport {
    left: var(--ia-panel-w);
    width: calc(100% - var(--ia-panel-w));
}

/* Display (static banner) has no "shrink to make room" concept the way OLV's
   video does — the image stays full screen at all times, in every layout;
   the Side Panel itself still slides in with the same animation, it just
   floats over the full-screen image instead of the image shrinking away
   from it. */
.ia-video-frame.ia-format-display.panel-right .ia-video-viewport,
.ia-video-frame.ia-format-display.panel-left .ia-video-viewport {
    left: 0;
    width: 100%;
}

/* Horizontal Panel reserves a strip at the bottom of the frame for the
   product panel — the video viewport shrinks to make room instead of the
   panel floating on top of it, matching how Side Panel already makes room
   by shrinking width instead of overlapping the creative. */
.ia-video-frame.ia-layout-horizontalPanel .ia-video-viewport {
    height: calc(100% - var(--ia-bottom-h));
}

.ia-ad-mock-media {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
}

/* A decoration rises up with a soft glow without ever unmounting, so re-showing it
   after a layout/position change is a smooth transition, not a re-animation from
   scratch. */
.ia-overlay-decoration {
    position: absolute;
    opacity: 0;
    transform: scale(0.9) translateY(14px);
    pointer-events: none;
    box-shadow: 0 0 0 rgba(37, 99, 235, 0);
    transition: opacity 1.4s cubic-bezier(0.16, 1, 0.3, 1),
        transform 1.4s cubic-bezier(0.16, 1, 0.3, 1),
        box-shadow 1.4s ease,
        left 1.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.ia-overlay-decoration.visible {
    opacity: 1;
    transform: scale(1) translateY(0);
    pointer-events: auto;
    box-shadow: 0 2px 2px rgba(15, 23, 42, 0.25);
}

/* QR badge gets its own, more pronounced "grow" entrance (bigger scale delta +
   a slight bounce) instead of the subtler fade/slide shared by the product
   overlay, so revealing the QR code reads as a distinct, attention-grabbing
   pop rather than the same generic rise-and-fade. */
.ia-ad-mock-qr.ia-overlay-decoration {
    transform: scale(0.35) translateY(10px);
    transition: opacity 1.6s cubic-bezier(0.22, 0.9, 0.3, 1),
        transform 1.6s cubic-bezier(0.22, 0.9, 0.3, 1),
        box-shadow 1.6s ease,
        left 1.6s cubic-bezier(0.16, 1, 0.3, 1);
}

.ia-ad-mock-qr.ia-overlay-decoration.visible {
    transform: scale(1) translateY(0);
    opacity: 0.9;
}

/* QR badge (Overlay layout) — always positioned via \`left\` (never \`right\`), so
   switching between Left / Right / Footer slides smoothly instead of snapping. */
.ia-ad-mock-qr {
    --ia-badge-w: 76px;
    width: var(--ia-badge-w);
    bottom: 30px;
    left: 20px;
    background: rgba(17, 24, 39, 0.72);
    color: #fff;
    border-radius: 0;
    padding: 4px;
    text-align: center;
    box-sizing: border-box;
    box-shadow: 0 2px 2px rgba(15, 23, 42, 0.25);
    z-index: 0;
}

.ia-ad-mock-qr.ia-qr-left { left: 20px; }
.ia-ad-mock-qr.ia-qr-right { left: calc(100% - var(--ia-badge-w) - 20px); }
.ia-ad-mock-qr.ia-qr-footer { left: calc(50% - var(--ia-badge-w) / 2); }

.ia-ad-mock-qr .ia-qr-image {
    display: block;
    width: 100%;
    height: auto;
    max-width: 58px;
    margin: 0 auto;
    background: #fff;
    border-radius: 2px;
    padding: 2px;
    box-sizing: border-box;
}

.ia-ad-mock-qr span {
    display: block;
    font-size: 8px;
    font-weight: 700;
    margin-top: 4px;
    text-transform: uppercase;
}

/* Side Panel layout: a fixed-width panel that slides flush against whichever edge
   is selected, sharing --ia-panel-w with the video viewport above so both move
   together as one continuous transition. */
.ia-qr-sidepanel,
.ia-product-panel-side {
    position: absolute;
    top: 0;
    left: 100%;
    width: 0;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    background: linear-gradient(160deg, #1f2937, #0f172a);
    color: #111827;
    box-shadow: none;
    z-index: 0;
    transform: translateX(16px);
    transition: left 0.5s cubic-bezier(0.16, 1, 0.3, 1),
        width 0.5s cubic-bezier(0.16, 1, 0.3, 1),
        box-shadow 0.5s ease,
        transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);
}

.ia-video-frame.panel-right .ia-qr-sidepanel,
.ia-video-frame.panel-right .ia-product-panel-side {
    left: calc(100% - var(--ia-panel-w));
    width: var(--ia-panel-w);
    box-shadow: none;
    transform: translateX(0);
}

.ia-video-frame.panel-left .ia-qr-sidepanel,
.ia-video-frame.panel-left .ia-product-panel-side {
    left: 0;
    width: var(--ia-panel-w);
    box-shadow: none;
    transform: translateX(0);
}

.ia-qr-sidepanel-inner,
.ia-product-panel-side-inner {
    width: var(--ia-panel-w);
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 6px;
    opacity: 0;
    transform: scale(0.88);
    transform-origin: center;
    transition: opacity 0.6s ease 0.25s, transform 1.2s cubic-bezier(0.18, 0.9, 0.22, 1) 0.25s;
}

/* Side Panel reveal (QR and Shoppable both) gets a slower, smoother fade/grow
   — the "clean video first" delay makes this the moment users' eyes land on,
   so the reveal itself should feel unhurried rather than snappy. */
.ia-qr-sidepanel-inner,
.ia-product-panel-side-inner {
    transition: opacity 1.6s ease 0.2s, transform 1.8s cubic-bezier(0.18, 0.9, 0.22, 1) 0.2s;
}

.ia-video-frame.panel-left .ia-qr-sidepanel-inner.visible,
.ia-video-frame.panel-right .ia-qr-sidepanel-inner.visible,
.ia-video-frame.panel-left .ia-product-panel-side-inner.visible,
.ia-video-frame.panel-right .ia-product-panel-side-inner.visible {
    opacity: 1;
    transform: scale(1);
}

.ia-video-frame.panel-left .ia-ad-mock-qr,
.ia-video-frame.panel-right .ia-ad-mock-qr {
    display: none !important;
    opacity: 0 !important;
    visibility: hidden !important;
    pointer-events: none !important;
}

.ia-qr-sidepanel-inner .ia-qr-image {
    display: block;
    width: 100%;
    max-width: 48px;
    height: auto;
    margin: 0 auto;
    background: #fff;
    border-radius: 4px;
    padding: 2px;
    box-sizing: border-box;
    transform: scale(0.45);
    opacity: 0.6;
    transition: transform 1.8s cubic-bezier(0.18, 0.9, 0.22, 1) 0.35s, opacity 1.4s ease 0.35s;
}

.ia-video-frame.panel-left .ia-qr-sidepanel-inner.visible .ia-qr-image,
.ia-video-frame.panel-right .ia-qr-sidepanel-inner.visible .ia-qr-image {
    transform: scale(1.12);
    opacity: 1;
}

.ia-qr-sidepanel-inner span {
    font-size: 9px;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
    color: #fff;
}

/* The QR side panel only ever holds an icon + one line of text, so it doesn't
   need the same width the product side panel reserves for a full chip — a
   narrower panel keeps it from looking like a mostly-empty slab and leaves
   more width for the video/ad itself. */
.ia-qr-frame {
    --ia-panel-w: 84px;
}

/* Mobile keeps the ad's native 16:9 shape (not stretched to fill the portrait
   frame), just scaled down — so the QR badge / product panel stay confined to
   the ad's own, shorter height. */
.ia-preview-frame-phone .ia-ad-mock-qr {
    --ia-badge-w: 52px;
    top: auto;
    bottom: 55px;
    left: 12px;
    padding: 5px;
}

.ia-preview-frame-phone .ia-ad-mock-qr.ia-qr-right {
    left: auto;
    right: 12px;
}

.ia-preview-frame-phone .ia-ad-mock-qr.ia-overlay-decoration {
    transform: scale(0.8);
}

.ia-preview-frame-phone .ia-ad-mock-qr.ia-overlay-decoration.visible {
    transform: scale(1) translateY(0);
    opacity: 0.9;
}

.ia-preview-frame-phone .ia-ad-mock-qr .ia-qr-image {
    max-width: 40px;
}

.ia-preview-frame-phone .ia-ad-mock-qr span {
    font-size: 7px;
    white-space: nowrap;
}

.ia-preview-frame-phone .ia-video-frame {
    --ia-panel-w: 70px;
    flex: 1 1;
    width: 100%;
    height: 100%;
    min-height: 0;
    max-height: none;
    aspect-ratio: auto;
}

.ia-preview-frame-phone .ia-qr-sidepanel-inner,
.ia-preview-frame-phone .ia-product-panel-side-inner {
    gap: 2px;
    padding: 4px;
}

.ia-preview-frame-phone .ia-qr-sidepanel-inner span {
    font-size: 7px;
    white-space: nowrap;
}

.ia-preview-frame-phone .ia-qr-sidepanel-inner .ia-qr-image {
    max-width: 36px;
}

/* The QR ad keeps its native 16:9 shape even in the mobile preview, instead of
   the generic phone frame above (which stretches to fill whatever's left of
   the phone body) — a fixed 16:9 box sized off the frame's own width, with
   ia-preview-phone-fill absorbing the leftover height below it, like empty
   phone chrome around a native ad slot. */
.ia-preview-frame-phone .ia-qr-frame {
    --ia-panel-w: 56px;
    flex: 0 0 auto;
    width: 100%;
    height: auto;
    aspect-ratio: 9 / 16;
    max-height: 100%;
}

/* ---------- Layout toggle (Overlay / Side Panel) ---------- */

.ia-layout-toggle {
    display: flex;
    gap: 10px;
    margin-bottom: 16px;
}

.ia-toggle-btn {
    flex: 1 1;
    padding: 12px;
    background: #fff;
    border: 1px solid var(--ia-border);
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    color: var(--ia-text);
    cursor: pointer;
}

.ia-toggle-btn.active {
    border: 2px solid var(--ia-text);
}

/* ---------- Animations ---------- */

@keyframes ia-fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
}

@keyframes ia-pop-in {
    from { opacity: 0; transform: scale(0.94) translateY(4px); }
    to { opacity: 1; transform: scale(1) translateY(0); }
}

/* Deliberately slower than a typical UI micro-interaction so the change reads
   clearly to the user, in both the desktop TV preview and the mobile popup — but
   an ease-out with no overshoot, so it settles cleanly instead of bouncing. */
.ia-anim-fade {
    animation: ia-fade-in 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

.ia-anim-pop {
    animation: ia-pop-in 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

/* ---------- Generic modal (used for the mobile preview popup) ---------- */

.ia-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(15, 15, 20, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
    padding: 20px;
}

.ia-modal {
    width: 100%;
    max-width: 430px;
    max-height: 90vh;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    animation: ia-fade-in 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.ia-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid var(--ia-border);
}

.ia-modal-title {
    font-size: 16px;
    font-weight: 700;
    margin: 0;
}

.ia-modal-close {
    background: none;
    border: none;
    font-size: 18px;
    color: var(--ia-muted);
    cursor: pointer;
    line-height: 1;
}

.ia-modal-body {
    padding: 20px;
    overflow-y: auto;
}

.ia-modal-body-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 420px;
}

/* Shoppable's product card: a square thumb on the left, a caption + CTA bar
   stacked in a column on the right — styled after a typical shoppable-video
   product overlay widget (thumb | name+expand / CTA bar), rather than the
   thumb-with-caption-underneath chip this used to be. */
.ia-product-chip {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(169, 155, 155, 0.6);
    color: #111827;
    border-radius: 10px;
    padding: 6px;
    width: 64px;
    flex-shrink: 0;
    text-align: left;
}

.ia-product-chip-thumb {
    width: 76px;
    height: 76px;
    aspect-ratio: 1;
    border-radius: 6px;
    background: #fff;
    object-fit: cover;
    flex-shrink: 0;
    box-shadow: none;
    filter: none;
}

.ia-product-chip-info {
    flex: 1 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.ia-product-chip-title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
}

.ia-product-chip-expand {
    position: absolute;
    top: 6px;
    right: 6px;
    font-size: 10px;
    color: rgba(17, 24, 39, 0.55);
    background: transparent;
    flex-shrink: 0;
}

.ia-product-chip-caption {
    font-size: 18px;
    font-weight: 700;
    color: #111827;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-shadow: none;
}

.ia-product-chip-cta {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    width: 130px;
    padding: 7px 10px;
    border-radius: 999px;
    background: #FFD100;
    color: #111827;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: 'Gilroy-SemiBold', 'Gilroy-Medium', 'Gilroy', sans-serif;
}

.ia-product-chip-cta i {
    font-size: 11px;
}

/* Shoppable configure page's product panel (Horizontal Panel / Overlay / Side Panel) */
.ia-preview-frame-phone .ia-product-chip {
    width: 38px;
    flex-shrink: 0;
    padding: 0;
}

.ia-product-strip {
    display: flex;
    align-items: center;
    gap: 0px;
    overflow: hidden;
}

.ia-product-strip.grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
}

.ia-product-strip .ia-product-chip {
    width: 46px;
    flex-shrink: 0;
}

.ia-product-strip.grid .ia-product-chip {
    width: auto;
}

.ia-preview-shop-btn-small {
    width: 100%;
    padding: 6px 10px;
    border: none;
    border-radius: 999px;
    background: var(--ia-primary);
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    font-family: 'Gilroy-SemiBold', 'Gilroy-Medium', 'Gilroy', sans-serif;
    cursor: default;
}

/* Horizontal Panel layout: full-width bar in the frame's reserved bottom strip
   (--ia-bottom-h, shrunk out of the video viewport above), so it sits below
   the creative instead of over it. The strip is centered rather than
   left-aligned so it doesn't leave a stretch of empty bar to the right of a
   short (carousel) row of chips. Bottom corners match the frame's own radius
   since this bar is flush against the frame's real bottom edge. */
.ia-product-panel-horizontal {
    left: 0;
    right: 0;
    bottom: 0;
    height: var(--ia-bottom-h);
    background: rgba(0, 0, 0, 0.15);
    padding: 3px 14px;
    box-sizing: border-box;
    border-radius: 0 0 8px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ia-product-panel-horizontal .ia-product-strip.grid {
    grid-template-columns: repeat(4, 1fr);
}

/* Chip size synced across all three layouts — using Overlay's size as the
   shared reference for Horizontal Panel and Side Panel too. */
.ia-product-panel-horizontal .ia-product-strip .ia-product-chip {
    width: 62px;
}

/* Neither panel needs the generic .ia-overlay-decoration "rise with a glow"
   drop-shadow (that's meant for the QR badge floating over the video) — the
   product panel already has its own translucent background, so the added
   shadow just looked like an unwanted halo behind the small chip images. */
.ia-product-panel-horizontal.ia-overlay-decoration.visible,
.ia-product-panel-overlay.ia-overlay-decoration.visible {
    box-shadow: none;
}

/* Overlay layout: compact panel floats over the ad, anchored to Footer (center) / Left / Right.
   Sized to hug the chip exactly like Side Panel does (--ia-badge-w == chip
   width, no outer padding) instead of leaving the chip floating inside a
   wider fixed-width badge — that gap was the extra white space. */
.ia-product-panel-overlay {
    --ia-badge-w: 62px;
    width: var(--ia-badge-w);
    bottom: 20px;
    background: rgba(255, 255, 255, 0.6);
    border-radius: 6px;
    padding: 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ia-product-panel-overlay .ia-product-strip {
    width: 100%;
}

.ia-product-panel-overlay .ia-product-strip .ia-product-chip {
    width: 62px;
}

.ia-product-panel-overlay.ia-pp-left { left: 20px; }
.ia-product-panel-overlay.ia-pp-right { left: calc(100% - var(--ia-badge-w) - 20px); }
.ia-product-panel-overlay.ia-pp-footer { left: calc(50% - var(--ia-badge-w) / 2); }

.ia-product-panel-side .ia-product-strip {
    flex-direction: column;
}

.ia-product-panel-side .ia-product-strip .ia-product-chip {
    width: 62px;
}

/* Scaled-down sizing when rendered inside the narrow mobile frame */
.ia-preview-frame-phone .ia-product-panel-horizontal .ia-product-strip .ia-product-chip {
    width: 38px;
}

.ia-preview-frame-phone .ia-product-panel-overlay {
    --ia-badge-w: 225px;
    height: 80px;
    padding: 0;
}

.ia-preview-frame-phone .ia-product-panel-overlay .ia-product-strip .ia-product-chip {
    width: 100%;
}

.ia-preview-frame-phone .ia-product-panel-side .ia-product-strip .ia-product-chip {
    width: 38px;
}

.ia-format-desc {
    color: var(--ia-muted);
    font-size: 13px;
    margin: 14px 0 12px;
}

.ia-supported-on-label {
    font-size: 12px;
    font-weight: 700;
    color: var(--ia-text);
    margin-bottom: 8px;
    display: block;
    font-family: 'Gilroy-Bold', 'Gilroy', sans-serif;
}

.ia-supported-on-row {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;
}

.ia-supported-chip {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: var(--ia-muted);
    font-family: 'Gilroy-Medium', 'Gilroy', sans-serif;
}

.ia-configure-btn {
    width: 100%;
    justify-content: center;
    margin-top: auto;
}

.ia-configure-btn-row {
    display: flex;
    gap: 10px;
    margin-top: auto;
}

.ia-configure-btn-row .ia-configure-btn {
    margin-top: 0;
}

/* ---------- Value strip ---------- */

.ia-value-strip {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 20px;
    border: 1px solid var(--ia-border);
    border-radius: 12px;
    padding: 20px;
    margin-top: 32px;
}

.ia-value-item {
    display: flex;
    gap: 12px;
}

.ia-value-icon {
    color: var(--ia-primary);
    font-size: 20px;
    flex-shrink: 0;
    margin-top: 2px;
}

.ia-value-title {
    font-size: 13px;
    font-weight: 700;
    color: var(--ia-primary);
    margin: 0 0 2px;
}

.ia-value-desc {
    font-size: 12px;
    color: var(--ia-muted);
    margin: 0;
}

/* ---------- Configure pages ---------- */

.ia-back-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: var(--ia-muted);
    font-size: 13px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    margin-bottom: 14px;
}

.ia-back-link:hover {
    color: var(--ia-text);
}

.ia-configure-grid {
    display: grid;
    grid-template-columns: minmax(320px, 420px) 1fr;
    gap: 20px;
    align-items: start;
    margin-top: 20px;
}

@media (max-width: 900px) {
    .ia-configure-grid {
        grid-template-columns: 1fr;
    }
}

.ia-panel {
    background: #fff;
    border: 1px solid var(--ia-border);
    border-radius: 12px;
    padding: 20px;
}

.ia-panel-title {
    font-size: 15px;
    font-weight: 700;
    margin: 0 0 16px;
}

.ia-field-label {
    display: block;
    font-size: 13px;
    font-weight: 700;
    color: var(--ia-text);
    margin-bottom: 8px;
}

.ia-required {
    color: #dc2626;
}

.ia-field-input {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid var(--ia-border);
    border-radius: 6px;
    font-size: 14px;
    box-sizing: border-box;
    margin-bottom: 16px;
}

.ia-field-input:focus {
    outline: none;
    border-color: var(--ia-primary);
}

.ia-input-icon-wrap {
    position: relative;
    margin-bottom: 16px;
}

.ia-input-icon-wrap .ia-field-input {
    margin-bottom: 0;
    padding-right: 36px;
}

.ia-input-icon-wrap i {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--ia-muted);
    font-size: 13px;
}

.ia-select {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid var(--ia-border);
    border-radius: 6px;
    font-size: 14px;
    background: #fff;
    box-sizing: border-box;
    margin-bottom: 16px;
}

.ia-divider {
    height: 1px;
    background: var(--ia-border);
    margin: 4px 0 16px;
}

.ia-toggle-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 4px;
}

.ia-toggle-text {
    font-size: 13px;
    font-weight: 700;
}

.ia-toggle-help {
    font-size: 12px;
    color: var(--ia-muted);
    margin: 4px 0 16px;
}

.ia-switch {
    width: 38px;
    height: 22px;
    border-radius: 999px;
    background: #d1d5db;
    border: none;
    position: relative;
    cursor: pointer;
    flex-shrink: 0;
    padding: 0;
    transition: background 0.15s ease;
}

.ia-switch.on {
    background: var(--ia-primary);
}

.ia-switch-knob {
    position: absolute;
    top: 3px;
    left: 3px;
    width: 16px;
    height: 16px;
    background: #fff;
    border-radius: 50%;
    transition: transform 0.15s ease;
}

.ia-switch.on .ia-switch-knob {
    transform: translateX(16px);
}

.ia-radio-group {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 16px;
}

.ia-radio-option {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    cursor: pointer;
}

.ia-radio-option input {
    accent-color: var(--ia-primary);
    width: 15px;
    height: 15px;
    cursor: pointer;
}

.ia-file-chip {
    display: flex;
    align-items: center;
    gap: 10px;
    border: 1px solid var(--ia-border);
    border-radius: 8px;
    padding: 10px 12px;
    margin-bottom: 16px;
}

.ia-file-chip i.ia-file-icon {
    color: var(--ia-green);
    font-size: 18px;
}

.ia-file-chip-info {
    flex: 1 1;
    min-width: 0;
}

.ia-file-chip-name {
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ia-file-chip-size {
    font-size: 11px;
    color: var(--ia-muted);
}

.ia-file-chip i.ia-file-check {
    color: #16a34a;
}

.ia-file-chip-change {
    background: none;
    border: none;
    color: var(--ia-primary);
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    padding: 0;
    white-space: nowrap;
}

.ia-file-picker-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    border: 1px dashed var(--ia-border);
    border-radius: 8px;
    background: #fafafa;
    color: var(--ia-text);
    font-size: 13px;
    cursor: pointer;
    margin-bottom: 16px;
}

.ia-panel-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 8px;
}

/* ---------- Preview panel ---------- */

.ia-preview-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.ia-preview-frame-tv {
    width: 100%;
    max-width: 760px;
    background: #111827;
    border-radius: 14px;
    padding: 16px;
    box-sizing: border-box;
}

.ia-preview-tv-stand {
    position: relative;
    width: 130px;
    height: 10px;
    background: #111827;
    margin: 0 auto;
    border-radius: 0 0 6px 6px;
}

.ia-preview-tv-stand::after {
    content: '';
    position: relative;
    display: block;
    width: 190px;
    height: 5px;
    background: #111827;
    margin: 0 auto;
    border-radius: 4px;
    transform: translateX(-50%) translateY(10px);
    left: 50%;
}

/* Scaled-up sizing for the same ad-mock components when they render inside the
   larger desktop TV preview, so the frame doesn't look mostly empty. */
.ia-preview-frame-tv .ia-ad-mock-qr {
    /* --ia-badge-w: 112px; */
    /* padding: 12px; */
}

.ia-preview-frame-tv .ia-ad-mock-qr i {
    font-size: 48px;
}

.ia-preview-frame-tv .ia-ad-mock-qr span {
    font-size: 10px;
    margin-top: 6px;
}

.ia-preview-frame-tv .ia-video-frame {
    --ia-panel-w: 160px;
    --ia-bottom-h: 76px;
}

.ia-preview-frame-tv .ia-qr-frame {
    --ia-panel-w: 120px;
}

/* Shoppable's desktop/TV preview shows a vertical (9:16) mobile-style ad
   instead of a 16:9 landscape frame, since the creative is consumed as a
   vertical story/reel-style video — sized by height and centered in the
   wide TV card instead of stretching full-width. object-fit:cover fills
   that vertical frame edge-to-edge from the 16:9 source (cropping the
   sides). Panel sizing below is scaled down to match this narrower frame,
   reusing roughly the same proportions as the phone preview. */
.ia-preview-frame-tv .ia-shoppable-frame {
    --ia-panel-w: 90px;
    --ia-bottom-h: 90px;
    width: auto;
    height: 520px;
    aspect-ratio: 9 / 16;
    margin: 0 auto;
}

.ia-preview-frame-tv .ia-shoppable-frame .ia-ad-mock-media {
    object-fit: cover;
}

/* Side Panel on the TV/desktop preview: match the mobile preview exactly —
   the video switches to object-fit:contain so it visibly shrinks to fit the
   narrower area freed up for the panel, instead of staying cover-cropped
   (which just loses the video's edge and doesn't read as "shifting" at all). */
.ia-preview-frame-tv .ia-shoppable-frame.panel-left .ia-ad-mock-media,
.ia-preview-frame-tv .ia-shoppable-frame.panel-right .ia-ad-mock-media {
    object-fit: contain;
}

.ia-preview-frame-tv .ia-shoppable-frame .ia-product-panel-side .ia-product-strip .ia-product-chip {
    width: 44px;
}

.ia-preview-frame-tv .ia-shoppable-frame .ia-product-panel-horizontal .ia-product-strip .ia-product-chip {
    width: 44px;
}

.ia-preview-frame-tv .ia-shoppable-frame .ia-product-panel-overlay {
    --ia-badge-w: 44px;
    padding: 0;
}

.ia-preview-frame-tv .ia-shoppable-frame .ia-product-panel-overlay .ia-product-strip .ia-product-chip {
    width: 44px;
}

.ia-preview-frame-tv .ia-qr-sidepanel-inner,
.ia-preview-frame-tv .ia-product-panel-side-inner {
    padding: 16px;
    gap: 12px;
}

.ia-preview-frame-tv .ia-qr-sidepanel-inner i {
    font-size: 44px;
}

.ia-preview-frame-tv .ia-qr-sidepanel-inner span {
    font-size: 12px;
}

.ia-preview-frame-tv .ia-product-panel-side .ia-product-strip .ia-product-chip {
    width: 84px;
}

.ia-preview-frame-tv .ia-product-panel-horizontal {
    padding: 3px 0px;
    padding-bottom: 0px;
}

.ia-preview-frame-tv .ia-product-panel-horizontal .ia-product-strip .ia-product-chip {
    width: 56px;
}

.ia-preview-frame-tv .ia-product-panel-overlay {
    --ia-badge-w: 84px;
    padding: 0;
}

.ia-preview-frame-tv .ia-product-panel-overlay .ia-product-strip .ia-product-chip {
    width: 84px;
}

.ia-preview-frame-tv .ia-preview-shop-btn-small {
    font-size: 13px;
    padding: 10px;
}

/* Sized to a real phone's ~19.5:9 screen ratio (not just tall enough to wrap
   the status bar + ad) so the mockup reads as an actual phone. The ad itself
   still only occupies its native 16:9 height at the top; ia-preview-phone-fill
   soaks up the remaining height like the rest of a phone's screen, and the
   home indicator caps it off flush with the bottom corner radius instead of
   leaving the ad's own corner sitting awkwardly close to the bezel curve. */
.ia-preview-frame-phone {
    width: 260px;
    aspect-ratio: 9 / 19.5;
    background: #111827;
    border-radius: 28px;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

.ia-preview-phone-statusbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    padding: 4px 8px 8px;
}

.ia-preview-phone-statusbar .icons {
    display: flex;
    gap: 5px;
    font-size: 10px;
}

/* Soaks up whatever height a fixed-aspect ad (the QR frame's 9/16 box) leaves
   behind, so the rest of the phone body reads as empty chrome below the ad
   instead of the ad being stretched to fill it. No-op for formats whose frame
   already fills the full remaining height (flex:1 there leaves nothing for
   this to absorb). */
.ia-preview-phone-fill {
    display: block;
    flex: 1 1;
    min-height: 0;
}

.ia-preview-frame-phone .ia-video-frame {
    --ia-bottom-h: 58px;
    flex: 1 1;
    margin-top: 0;
    min-height: 0;
}

/* Mobile preview (QR and Shoppable both): the video fills the entire phone
   screen edge-to-edge (a true full-screen 9:16 vertical ad unit) instead of
   sitting in a boxed area with empty phone chrome around it. The status bar
   and home indicator float on top of the video (absolutely positioned)
   rather than sharing flow space with it, so the ad still reads as "full
   screen" underneath them — all existing features (QR badge/overlay, product
   panels, side panel) keep working since they're still rendered inside the
   same frame, just now stretched to fill the whole device instead of a
   smaller boxed area. Scoped to .ia-video-frame generically so both QR's
   .ia-qr-frame and Shoppable's .ia-shoppable-frame get identical treatment. */
.ia-preview-frame-phone.ia-preview-frame-phone-fullbleed {
    position: relative;
    aspect-ratio: 9 / 16;
    padding: 0;
    overflow: hidden;
}

.ia-preview-frame-phone-fullbleed .ia-preview-phone-statusbar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 2;
    padding: 14px 18px 8px;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0));
}

.ia-preview-frame-phone-fullbleed .ia-video-frame {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    aspect-ratio: auto;
    max-height: none;
    margin-top: 0;
    border-radius: 0;
}

.ia-preview-frame-phone-fullbleed .ia-video-frame .ia-ad-mock-media {
    object-fit: cover;
}

/* Display's banner fills the frame the same way OLV's video does — cover,
   scaling to fill edge-to-edge and cropping any aspect-ratio overflow —
   rather than stretching, so it always looks proportionally correct. */
.ia-preview-frame-phone-fullbleed .ia-video-frame.ia-format-display .ia-ad-mock-media {
    object-fit: cover;
}

/* Side Panel: match desktop's behavior exactly — the viewport shrinks width
   (via panel-left/panel-right + --ia-panel-w, same mechanism as desktop) and
   the video switches to object-fit:contain so it visibly shrinks to fit the
   narrower area, instead of staying cover-cropped and just losing its edge
   (which wouldn't read as "shrinking" at all). */
.ia-preview-frame-phone-fullbleed .ia-video-frame.panel-left .ia-ad-mock-media,
.ia-preview-frame-phone-fullbleed .ia-video-frame.panel-right .ia-ad-mock-media {
    object-fit: contain;
}

/* Display (static banner) falls back to the same object-fit:contain as OLV's
   video in Side Panel — the creative must never be cropped, so on Side Panel
   specifically it's shown fully (letterboxed if needed) rather than covering
   and cutting off part of the image. */

.ia-preview-frame-phone-fullbleed .ia-preview-phone-home-indicator {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    margin: 0;
}

/* Shoppable's mobile ad, like the QR frame, plays as a true 9:16 box sized
   off the frame's own width — instead of stretching to fill whatever's left
   of the phone body. object-fit:contain keeps the full 16:9 source visible
   (letterboxed above/below) rather than cropping its sides. Excludes the QR
   frame, which keeps its own native 16:9 box. */
.ia-preview-frame-phone .ia-video-frame:not(.ia-qr-frame):not(.ia-format-display) {
    flex: 0 0 auto;
    width: 100%;
    height: auto;
    aspect-ratio: 9 / 16;
    max-height: 100%;
}

.ia-preview-frame-phone .ia-video-frame:not(.ia-qr-frame):not(.ia-format-display) .ia-ad-mock-media {
    object-fit: contain;
}

.ia-preview-phone-home-indicator {
    flex-shrink: 0;
    align-self: center;
    width: 90px;
    height: 4px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.6);
    margin: 10px 0 2px;
}

.ia-simulated-note {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    color: var(--ia-muted);
    margin-top: 12px;
    font-style: italic;
}

/* ---------- "Generate Demo On Web Page" — a generic publisher page mockup
   with the ad creative dropped into its ad slot, centered, for a realistic
   in-context preview instead of just the bare mobile frame. ---------- */

.ia-webdemo-modal {
    position: relative;
    width: 100%;
    max-width: 1040px;
    max-height: 92vh;
    overflow-y: auto;
    background: #0b0d10;
    border-radius: 12px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
}

.ia-webdemo-close {
    position: sticky;
    top: 12px;
    left: 100%;
    margin-right: 12px;
    z-index: 5;
    color: #fff;
    background: rgba(255, 255, 255, 0.12);
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ia-webdemo-site {
    color: #e5e7eb;
    padding: 0 0 24px;
    font-family: 'Gilroy-Medium', 'Gilroy', sans-serif;
}

/* The background image's own yellow rectangle marks exactly where the ad
   should sit — sized to the image's native ratio so the ad-slot's percentage
   position below always lines up with that marker regardless of the
   modal's actual rendered width. */
.ia-webdemo-site-bg {
    position: relative;
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
    aspect-ratio: 2025 / 1494;
    background-image: none;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 0;
}

.ia-webdemo-nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 14px 24px;
    background: #000;
    flex-wrap: wrap;
}

.ia-webdemo-logo {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 800;
    font-size: 16px;
    color: #fff;
    letter-spacing: 0.02em;
}

.ia-webdemo-nav-links {
    display: flex;
    gap: 20px;
    font-size: 13px;
    font-weight: 700;
    color: #d1d5db;
    flex-wrap: wrap;
}

.ia-webdemo-login {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 700;
    color: #fff;
    white-space: nowrap;
}

.ia-webdemo-ad-label {
    text-align: center;
    font-size: 11px;
    color: #9ca3af;
    margin: 16px 0 8px;
}

.ia-webdemo-ad-slot {
    position: absolute;
    left: 51.5%;
    top: 23.4%;
    transform: translate(-50%, -50%);
    width: min(480px, 90%);
    aspect-ratio: 16 / 9;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    overflow: hidden;
}

/* The shoppable overlay card sits on top of the ad creative, bottom-center,
   same as it would in the real Overlay layout — reuses .ia-product-chip so
   sizing/colors stay in sync with the mobile preview automatically. */
.ia-webdemo-ad-overlay {
    position: absolute;
    left: 50%;
    bottom: 16px;
    width: 200px;
    z-index: 2;
}

/* .ia-overlay-decoration sets its own \`transform\` for the fade/scale reveal,
   which would otherwise wipe out the translateX(-50%) centering above — so
   both are combined into one transform value here, scoped specifically to
   this element. */
.ia-webdemo-ad-overlay.ia-overlay-decoration {
    transform: translateX(-50%) scale(0.9) translateY(14px);
}

.ia-webdemo-ad-overlay.ia-overlay-decoration.visible {
    transform: translateX(-50%) scale(1) translateY(0);
}

.ia-webdemo-ad-overlay .ia-product-chip {
    width: 100%;
}

.ia-webdemo-ad-overlay .ia-product-chip-cta {
    width: 100px;
}

.ia-webdemo-ad-media {
    width: 100%;
    height: 90%;
    object-fit: contain;
    display: block;
    margin: 0 auto;
}

.ia-webdemo-scores-bar {
    display: flex;
    gap: 10px;
    padding: 20px 24px 12px;
    flex-wrap: wrap;
}

.ia-webdemo-scores-tab {
    padding: 6px 14px;
    border-radius: 999px;
    background: #1c2128;
    font-size: 12px;
    font-weight: 700;
    color: #d1d5db;
}

.ia-webdemo-scores-tab.active {
    background: #fff;
    color: #111827;
}

.ia-webdemo-score-cards {
    display: flex;
    gap: 12px;
    padding: 0 24px 20px;
    flex-wrap: wrap;
}

.ia-webdemo-score-card {
    flex: 1 1;
    min-width: 200px;
    background: #14181d;
    border-radius: 8px;
    padding: 12px;
}

.ia-webdemo-score-comp {
    font-size: 11px;
    color: #9ca3af;
    margin-bottom: 8px;
}

.ia-webdemo-score-row {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    font-weight: 700;
    padding: 4px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.ia-webdemo-score-row:first-of-type {
    border-top: none;
}

.ia-webdemo-tiles {
    display: flex;
    gap: 12px;
    padding: 0 24px;
    flex-wrap: wrap;
}

.ia-webdemo-tile {
    flex: 1 1;
    min-width: 200px;
    background: #14181d;
    border-radius: 8px;
    overflow: hidden;
}

.ia-webdemo-tile-wide {
    flex: 2 1;
}

.ia-webdemo-tile-thumb {
    width: 100%;
    aspect-ratio: 16 / 9;
    background: linear-gradient(135deg, #1f2937, #374151);
}

.ia-webdemo-tile p {
    margin: 0;
    padding: 10px 12px;
    font-size: 12px;
    color: #d1d5db;
}

.ia-webdemo-note {
    padding: 0 24px 20px;
    color: #9ca3af;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/innovation-ads/innovation-ads.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,8DAA8D;IAC9D,aAAa;IACb,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA,iCAAiC;;AAEjC;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,gDAAgD;IAChD,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;IACX,6BAA6B;IAC7B,oBAAoB;IACpB,gDAAgD;AACpD;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,kDAAkD;IAClD,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,6BAA6B;IAC7B,mBAAmB;IACnB,qEAAqE;AACzE;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA,kDAAkD;;AAElD;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gDAAgD;IAChD,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,SAAS;IACT,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,uCAAuC;;AAEvC;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,gDAAgD;IAChD,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,kDAAkD;AACtD;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,YAAY;AAChB;;AAEA;oEACoE;AACpE;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,8CAA8C;AAC9C;;;;;;;;;;gEAUgE;;AAEhE;IACI,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,qDAAqD;IACrD,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB;iDAC6C;AACjD;;AAEA;IACI,OAAO;IACP,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;AACzC;;AAEA;;;;aAIa;AACb;;IAEI,OAAO;IACP,WAAW;AACf;;AAEA;;;4DAG4D;AAC5D;IACI,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;aAEa;AACb;IACI,kBAAkB;IAClB,UAAU;IACV,sCAAsC;IACtC,oBAAoB;IACpB,sCAAsC;IACtC;;;+CAG2C;AAC/C;;AAEA;IACI,UAAU;IACV,iCAAiC;IACjC,oBAAoB;IACpB,4CAA4C;AAChD;;AAEA;;;oDAGoD;AACpD;IACI,uCAAuC;IACvC;;;+CAG2C;AAC/C;;AAEA;IACI,iCAAiC;IACjC,YAAY;AAChB;;AAEA;iFACiF;AACjF;IACI,kBAAkB;IAClB,wBAAwB;IACxB,YAAY;IACZ,UAAU;IACV,kCAAkC;IAClC,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,4CAA4C;IAC5C,UAAU;AACd;;AAEA,4BAA4B,UAAU,EAAE;AACxC,6BAA6B,2CAA2C,EAAE;AAC1E,8BAA8B,uCAAuC,EAAE;;AAEvE;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;;2CAE2C;AAC3C;;IAEI,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,qDAAqD;IACrD,cAAc;IACd,gBAAgB;IAChB,UAAU;IACV,2BAA2B;IAC3B;;;oDAGgD;AACpD;;AAEA;;IAEI,oCAAoC;IACpC,wBAAwB;IACxB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;;IAEI,OAAO;IACP,wBAAwB;IACxB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;;IAEI,wBAAwB;IACxB,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,sBAAsB;IACtB,wBAAwB;IACxB,0FAA0F;AAC9F;;AAEA;;mEAEmE;AACnE;;IAEI,wFAAwF;AAC5F;;AAEA;;;;IAII,UAAU;IACV,mBAAmB;AACvB;;AAEA;;IAEI,wBAAwB;IACxB,qBAAqB;IACrB,6BAA6B;IAC7B,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;IACZ,0FAA0F;AAC9F;;AAEA;;IAEI,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;AACf;;AAEA;;;wCAGwC;AACxC;IACI,kBAAkB;AACtB;;AAEA;;kCAEkC;AAClC;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;0CAI0C;AAC1C;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA,+DAA+D;;AAE/D;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA,qCAAqC;;AAErC;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;;AAEA;IACI,OAAO,UAAU,EAAE,sCAAsC,EAAE;IAC3D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;;8EAE8E;AAC9E;IACI,wDAAwD;AAC5D;;AAEA;IACI,uDAAuD;AAC3D;;AAEA,4EAA4E;;AAE5E;IACI,eAAe;IACf,QAAQ;IACR,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,2CAA2C;IAC3C,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,wDAAwD;AAC5D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;;;wDAGwD;AACxD;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,oCAAoC;IACpC,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,6BAA6B;IAC7B,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,qEAAqE;AACzE;;AAEA;IACI,eAAe;AACnB;;AAEA,uFAAuF;AACvF;IACI,WAAW;IACX,cAAc;IACd,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;IACpB,6BAA6B;IAC7B,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,qEAAqE;IACrE,eAAe;AACnB;;AAEA;;;;;kEAKkE;AAClE;IACI,OAAO;IACP,QAAQ;IACR,SAAS;IACT,0BAA0B;IAC1B,+BAA+B;IAC/B,iBAAiB;IACjB,sBAAsB;IACtB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;8DAC8D;AAC9D;IACI,WAAW;AACf;;AAEA;;;2EAG2E;AAC3E;;IAEI,gBAAgB;AACpB;;AAEA;;;kEAGkE;AAClE;IACI,kBAAkB;IAClB,wBAAwB;IACxB,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA,uCAAuC,UAAU,EAAE;AACnD,wCAAwC,2CAA2C,EAAE;AACrF,yCAAyC,uCAAuC,EAAE;;AAElF;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA,oEAAoE;AACpE;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,sBAAsB;IACtB,kDAAkD;AACtD;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA,sCAAsC;;AAEtC;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,kCAAkC;IAClC,mBAAmB;IACnB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,SAAS;AACb;;AAEA,0CAA0C;;AAE1C;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,+CAA+C;IAC/C,SAAS;IACT,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,UAAU;IACV,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kCAAkC;IAClC,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,mCAAmC;IACnC,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,eAAe;AACnB;;AAEA,wCAAwC;;AAExC;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,4CAA4C;IAC5C,SAAS;AACb;;AAEA;uEACuE;AACvE;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;;;;+DAM+D;AAC/D;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;;+EAG+E;AAC/E;;IAEI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;;;;;4EAK4E;AAC5E;IACI,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;;;;qBAIqB;AACrB;IACI,cAAc;IACd,SAAO;IACP,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,SAAO;IACP,aAAa;IACb,aAAa;AACjB;;AAEA;;;;;;;;;8EAS8E;AAC9E;IACI,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,UAAU;IACV,sBAAsB;IACtB,6EAA6E;AACjF;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;uEAEuE;AACvE;IACI,iBAAiB;AACrB;;AAEA;;;;iDAIiD;AACjD;;IAEI,mBAAmB;AACvB;;AAEA;;;uCAGuC;;AAEvC;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,SAAS;AACb;;AAEA;;;;gDAIgD;AAChD;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;yEAEyE;;AAEzE;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,qCAAqC;IACrC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kDAAkD;AACtD;;AAEA;;;mCAGmC;AACnC;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;IAC1B,4BAA4B;IAC5B,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,gCAAgC;IAChC,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;sEAEsE;AACtE;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,UAAU;AACd;;AAEA;;;kBAGkB;AAClB;IACI,uDAAuD;AAC3D;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,qDAAqD;AACzD;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,cAAc;AAClB","sourcesContent":[".ia-page {\n    --ia-primary: #0049AA;\n    --ia-primary-dark: #003d90;\n    --ia-purple: #7c3aed;\n    --ia-green: #16a34a;\n    --ia-border: #e5e7eb;\n    --ia-muted: #6b7280;\n    --ia-text: #111827;\n    font-family: 'Gilroy', 'Gilroy-Medium', 'Segoe UI', sans-serif;\n    padding: 24px;\n    color: var(--ia-text);\n    letter-spacing: 0.01em;\n}\n\n/* ---------- Header ---------- */\n\n.ia-header-row {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    flex-wrap: wrap;\n}\n\n.ia-title-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.ia-title {\n    font-size: 22px;\n    font-weight: 800;\n    margin: 0;\n    font-family: 'Gilroy-Bold', 'Gilroy', sans-serif;\n    color: var(--ia-primary);\n}\n\n.ia-badge-new {\n    display: inline-block;\n    padding: 2px 10px;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n    color: #fff;\n    background: var(--ia-primary);\n    border-radius: 999px;\n    font-family: 'Gilroy-Bold', 'Gilroy', sans-serif;\n}\n\n.ia-subheading {\n    color: var(--ia-muted);\n    margin: 6px 0 0;\n    max-width: 640px;\n    font-family: 'Gilroy-Medium', 'Gilroy', sans-serif;\n    font-size: 14px;\n    line-height: 1.5;\n}\n\n.ia-btn {\n    padding: 9px 16px;\n    border-radius: 999px;\n    font-size: 14px;\n    font-weight: 700;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    border: 1px solid transparent;\n    white-space: nowrap;\n    font-family: 'Gilroy-SemiBold', 'Gilroy-Medium', 'Gilroy', sans-serif;\n}\n\n.ia-btn-outline {\n    background: #fff;\n    border-color: var(--ia-primary);\n    color: var(--ia-primary);\n}\n\n.ia-btn-outline:hover {\n    background: #eff6ff;\n}\n\n.ia-btn-primary {\n    background: var(--ia-primary);\n    border-color: var(--ia-primary);\n    color: #fff;\n}\n\n.ia-btn-primary:hover {\n    background: var(--ia-primary-dark);\n}\n\n.ia-btn-primary:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.ia-btn-plain {\n    background: #fff;\n    border-color: var(--ia-border);\n    color: var(--ia-text);\n}\n\n/* ---------- Popular Formats section ---------- */\n\n.ia-section-header-row {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    margin-top: 32px;\n    flex-wrap: wrap;\n}\n\n.ia-section-title {\n    font-size: 17px;\n    font-weight: 700;\n    margin: 0 0 4px;\n    font-family: 'Gilroy-Bold', 'Gilroy', sans-serif;\n    color: var(--ia-primary);\n}\n\n.ia-section-subtext {\n    color: var(--ia-muted);\n    font-size: 13px;\n    margin: 0;\n    font-family: 'Gilroy-Medium', 'Gilroy', sans-serif;\n}\n\n.ia-section-controls {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.ia-filter-select {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 14px;\n    border: 1px solid var(--ia-border);\n    border-radius: 8px;\n    font-size: 13px;\n    background: #fff;\n    color: var(--ia-text);\n}\n\n.ia-info-icon {\n    color: var(--ia-muted);\n}\n\n/* ---------- Format cards ---------- */\n\n.ia-cards-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));\n    gap: 20px;\n    margin-top: 16px;\n}\n\n.ia-format-card {\n    background: #fff;\n    border: 1px solid var(--ia-border);\n    border-radius: 12px;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n}\n\n.ia-format-card-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n.ia-format-icon {\n    width: 40px;\n    height: 40px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 18px;\n    margin-bottom: 10px;\n}\n\n.ia-format-icon.purple {\n    background: #f2eaff;\n    color: var(--ia-purple);\n}\n\n.ia-format-icon.green {\n    background: #e6f6ec;\n    color: var(--ia-green);\n}\n\n.ia-format-title {\n    font-size: 16px;\n    font-weight: 700;\n    margin: 0;\n    font-family: 'Gilroy-Bold', 'Gilroy', sans-serif;\n    color: var(--ia-text);\n}\n\n.ia-format-tag {\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--ia-primary);\n    font-family: 'Gilroy-Medium', 'Gilroy', sans-serif;\n}\n\n.ia-format-menu-btn {\n    background: none;\n    border: none;\n    color: var(--ia-muted);\n    cursor: pointer;\n    font-size: 16px;\n    padding: 4px;\n}\n\n/* Static poster image on the listing page — the interactive video/gif preview\n   only appears once the user opens a format's own configure page. */\n.ia-format-preview-img {\n    display: block;\n    width: 100%;\n    height: 320px;\n    object-fit: cover;\n    object-position: center;\n    border-radius: 8px;\n    margin-top: 14px;\n    background: #f3f4f6;\n}\n\n/* ---------- Ad creative preview ---------- */\n/* One persistent structure shared by QR Code and Shoppable: a real video/gif fills\n   the viewport at all times (never remounted, so playback is continuous), and\n   layout \"decorations\" (QR badge, product panel, side panel) rise/glow in on top\n   of it. The video viewport and the side panel are both absolutely positioned and\n   share the same --ia-panel-w custom property, so BOTH the expand/collapse (layout\n   change) AND the left/right swap (position change) are smooth, continuous\n   transitions rather than instant snaps. The video itself always keeps its source\n   aspect ratio via object-fit: contain, so resizing it never stretches or crops\n   the footage — and on mobile it keeps its native 16:9 shape (instead of being\n   stretched to fill the whole portrait screen) so the QR/product decorations stay\n   confined to the ad's own height, not the full phone height. */\n\n.ia-video-frame {\n    --ia-panel-w: 110px;\n    --ia-bottom-h: 105px;\n    position: relative;\n    margin-top: 14px;\n    aspect-ratio: 16 / 9;\n    border-radius: 8px;\n    background: linear-gradient(160deg, #1f2937, #0f172a);\n    overflow: hidden;\n    color: #fff;\n}\n\n.ia-video-viewport {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    transition: left 0.5s cubic-bezier(0.16, 1, 0.3, 1), width 0.5s cubic-bezier(0.16, 1, 0.3, 1),\n        height 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.ia-video-frame.panel-right .ia-video-viewport {\n    left: 0;\n    width: calc(100% - var(--ia-panel-w));\n}\n\n.ia-video-frame.panel-left .ia-video-viewport {\n    left: var(--ia-panel-w);\n    width: calc(100% - var(--ia-panel-w));\n}\n\n/* Display (static banner) has no \"shrink to make room\" concept the way OLV's\n   video does — the image stays full screen at all times, in every layout;\n   the Side Panel itself still slides in with the same animation, it just\n   floats over the full-screen image instead of the image shrinking away\n   from it. */\n.ia-video-frame.ia-format-display.panel-right .ia-video-viewport,\n.ia-video-frame.ia-format-display.panel-left .ia-video-viewport {\n    left: 0;\n    width: 100%;\n}\n\n/* Horizontal Panel reserves a strip at the bottom of the frame for the\n   product panel — the video viewport shrinks to make room instead of the\n   panel floating on top of it, matching how Side Panel already makes room\n   by shrinking width instead of overlapping the creative. */\n.ia-video-frame.ia-layout-horizontalPanel .ia-video-viewport {\n    height: calc(100% - var(--ia-bottom-h));\n}\n\n.ia-ad-mock-media {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    display: block;\n}\n\n/* A decoration rises up with a soft glow without ever unmounting, so re-showing it\n   after a layout/position change is a smooth transition, not a re-animation from\n   scratch. */\n.ia-overlay-decoration {\n    position: absolute;\n    opacity: 0;\n    transform: scale(0.9) translateY(14px);\n    pointer-events: none;\n    box-shadow: 0 0 0 rgba(37, 99, 235, 0);\n    transition: opacity 1.4s cubic-bezier(0.16, 1, 0.3, 1),\n        transform 1.4s cubic-bezier(0.16, 1, 0.3, 1),\n        box-shadow 1.4s ease,\n        left 1.4s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.ia-overlay-decoration.visible {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n    pointer-events: auto;\n    box-shadow: 0 2px 2px rgba(15, 23, 42, 0.25);\n}\n\n/* QR badge gets its own, more pronounced \"grow\" entrance (bigger scale delta +\n   a slight bounce) instead of the subtler fade/slide shared by the product\n   overlay, so revealing the QR code reads as a distinct, attention-grabbing\n   pop rather than the same generic rise-and-fade. */\n.ia-ad-mock-qr.ia-overlay-decoration {\n    transform: scale(0.35) translateY(10px);\n    transition: opacity 1.6s cubic-bezier(0.22, 0.9, 0.3, 1),\n        transform 1.6s cubic-bezier(0.22, 0.9, 0.3, 1),\n        box-shadow 1.6s ease,\n        left 1.6s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.ia-ad-mock-qr.ia-overlay-decoration.visible {\n    transform: scale(1) translateY(0);\n    opacity: 0.9;\n}\n\n/* QR badge (Overlay layout) — always positioned via `left` (never `right`), so\n   switching between Left / Right / Footer slides smoothly instead of snapping. */\n.ia-ad-mock-qr {\n    --ia-badge-w: 76px;\n    width: var(--ia-badge-w);\n    bottom: 30px;\n    left: 20px;\n    background: rgba(17, 24, 39, 0.72);\n    color: #fff;\n    border-radius: 0;\n    padding: 4px;\n    text-align: center;\n    box-sizing: border-box;\n    box-shadow: 0 2px 2px rgba(15, 23, 42, 0.25);\n    z-index: 0;\n}\n\n.ia-ad-mock-qr.ia-qr-left { left: 20px; }\n.ia-ad-mock-qr.ia-qr-right { left: calc(100% - var(--ia-badge-w) - 20px); }\n.ia-ad-mock-qr.ia-qr-footer { left: calc(50% - var(--ia-badge-w) / 2); }\n\n.ia-ad-mock-qr .ia-qr-image {\n    display: block;\n    width: 100%;\n    height: auto;\n    max-width: 58px;\n    margin: 0 auto;\n    background: #fff;\n    border-radius: 2px;\n    padding: 2px;\n    box-sizing: border-box;\n}\n\n.ia-ad-mock-qr span {\n    display: block;\n    font-size: 8px;\n    font-weight: 700;\n    margin-top: 4px;\n    text-transform: uppercase;\n}\n\n/* Side Panel layout: a fixed-width panel that slides flush against whichever edge\n   is selected, sharing --ia-panel-w with the video viewport above so both move\n   together as one continuous transition. */\n.ia-qr-sidepanel,\n.ia-product-panel-side {\n    position: absolute;\n    top: 0;\n    left: 100%;\n    width: 0;\n    height: 100%;\n    box-sizing: border-box;\n    overflow: hidden;\n    background: linear-gradient(160deg, #1f2937, #0f172a);\n    color: #111827;\n    box-shadow: none;\n    z-index: 0;\n    transform: translateX(16px);\n    transition: left 0.5s cubic-bezier(0.16, 1, 0.3, 1),\n        width 0.5s cubic-bezier(0.16, 1, 0.3, 1),\n        box-shadow 0.5s ease,\n        transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.ia-video-frame.panel-right .ia-qr-sidepanel,\n.ia-video-frame.panel-right .ia-product-panel-side {\n    left: calc(100% - var(--ia-panel-w));\n    width: var(--ia-panel-w);\n    box-shadow: none;\n    transform: translateX(0);\n}\n\n.ia-video-frame.panel-left .ia-qr-sidepanel,\n.ia-video-frame.panel-left .ia-product-panel-side {\n    left: 0;\n    width: var(--ia-panel-w);\n    box-shadow: none;\n    transform: translateX(0);\n}\n\n.ia-qr-sidepanel-inner,\n.ia-product-panel-side-inner {\n    width: var(--ia-panel-w);\n    height: 100%;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    padding: 6px;\n    opacity: 0;\n    transform: scale(0.88);\n    transform-origin: center;\n    transition: opacity 0.6s ease 0.25s, transform 1.2s cubic-bezier(0.18, 0.9, 0.22, 1) 0.25s;\n}\n\n/* Side Panel reveal (QR and Shoppable both) gets a slower, smoother fade/grow\n   — the \"clean video first\" delay makes this the moment users' eyes land on,\n   so the reveal itself should feel unhurried rather than snappy. */\n.ia-qr-sidepanel-inner,\n.ia-product-panel-side-inner {\n    transition: opacity 1.6s ease 0.2s, transform 1.8s cubic-bezier(0.18, 0.9, 0.22, 1) 0.2s;\n}\n\n.ia-video-frame.panel-left .ia-qr-sidepanel-inner.visible,\n.ia-video-frame.panel-right .ia-qr-sidepanel-inner.visible,\n.ia-video-frame.panel-left .ia-product-panel-side-inner.visible,\n.ia-video-frame.panel-right .ia-product-panel-side-inner.visible {\n    opacity: 1;\n    transform: scale(1);\n}\n\n.ia-video-frame.panel-left .ia-ad-mock-qr,\n.ia-video-frame.panel-right .ia-ad-mock-qr {\n    display: none !important;\n    opacity: 0 !important;\n    visibility: hidden !important;\n    pointer-events: none !important;\n}\n\n.ia-qr-sidepanel-inner .ia-qr-image {\n    display: block;\n    width: 100%;\n    max-width: 48px;\n    height: auto;\n    margin: 0 auto;\n    background: #fff;\n    border-radius: 4px;\n    padding: 2px;\n    box-sizing: border-box;\n    transform: scale(0.45);\n    opacity: 0.6;\n    transition: transform 1.8s cubic-bezier(0.18, 0.9, 0.22, 1) 0.35s, opacity 1.4s ease 0.35s;\n}\n\n.ia-video-frame.panel-left .ia-qr-sidepanel-inner.visible .ia-qr-image,\n.ia-video-frame.panel-right .ia-qr-sidepanel-inner.visible .ia-qr-image {\n    transform: scale(1.12);\n    opacity: 1;\n}\n\n.ia-qr-sidepanel-inner span {\n    font-size: 9px;\n    font-weight: 700;\n    text-transform: uppercase;\n    text-align: center;\n    color: #fff;\n}\n\n/* The QR side panel only ever holds an icon + one line of text, so it doesn't\n   need the same width the product side panel reserves for a full chip — a\n   narrower panel keeps it from looking like a mostly-empty slab and leaves\n   more width for the video/ad itself. */\n.ia-qr-frame {\n    --ia-panel-w: 84px;\n}\n\n/* Mobile keeps the ad's native 16:9 shape (not stretched to fill the portrait\n   frame), just scaled down — so the QR badge / product panel stay confined to\n   the ad's own, shorter height. */\n.ia-preview-frame-phone .ia-ad-mock-qr {\n    --ia-badge-w: 52px;\n    top: auto;\n    bottom: 55px;\n    left: 12px;\n    padding: 5px;\n}\n\n.ia-preview-frame-phone .ia-ad-mock-qr.ia-qr-right {\n    left: auto;\n    right: 12px;\n}\n\n.ia-preview-frame-phone .ia-ad-mock-qr.ia-overlay-decoration {\n    transform: scale(0.8);\n}\n\n.ia-preview-frame-phone .ia-ad-mock-qr.ia-overlay-decoration.visible {\n    transform: scale(1) translateY(0);\n    opacity: 0.9;\n}\n\n.ia-preview-frame-phone .ia-ad-mock-qr .ia-qr-image {\n    max-width: 40px;\n}\n\n.ia-preview-frame-phone .ia-ad-mock-qr span {\n    font-size: 7px;\n    white-space: nowrap;\n}\n\n.ia-preview-frame-phone .ia-video-frame {\n    --ia-panel-w: 70px;\n    flex: 1;\n    width: 100%;\n    height: 100%;\n    min-height: 0;\n    max-height: none;\n    aspect-ratio: auto;\n}\n\n.ia-preview-frame-phone .ia-qr-sidepanel-inner,\n.ia-preview-frame-phone .ia-product-panel-side-inner {\n    gap: 2px;\n    padding: 4px;\n}\n\n.ia-preview-frame-phone .ia-qr-sidepanel-inner span {\n    font-size: 7px;\n    white-space: nowrap;\n}\n\n.ia-preview-frame-phone .ia-qr-sidepanel-inner .ia-qr-image {\n    max-width: 36px;\n}\n\n/* The QR ad keeps its native 16:9 shape even in the mobile preview, instead of\n   the generic phone frame above (which stretches to fill whatever's left of\n   the phone body) — a fixed 16:9 box sized off the frame's own width, with\n   ia-preview-phone-fill absorbing the leftover height below it, like empty\n   phone chrome around a native ad slot. */\n.ia-preview-frame-phone .ia-qr-frame {\n    --ia-panel-w: 56px;\n    flex: 0 0 auto;\n    width: 100%;\n    height: auto;\n    aspect-ratio: 9 / 16;\n    max-height: 100%;\n}\n\n/* ---------- Layout toggle (Overlay / Side Panel) ---------- */\n\n.ia-layout-toggle {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 16px;\n}\n\n.ia-toggle-btn {\n    flex: 1;\n    padding: 12px;\n    background: #fff;\n    border: 1px solid var(--ia-border);\n    border-radius: 8px;\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--ia-text);\n    cursor: pointer;\n}\n\n.ia-toggle-btn.active {\n    border: 2px solid var(--ia-text);\n}\n\n/* ---------- Animations ---------- */\n\n@keyframes ia-fade-in {\n    from { opacity: 0; }\n    to { opacity: 1; }\n}\n\n@keyframes ia-pop-in {\n    from { opacity: 0; transform: scale(0.94) translateY(4px); }\n    to { opacity: 1; transform: scale(1) translateY(0); }\n}\n\n/* Deliberately slower than a typical UI micro-interaction so the change reads\n   clearly to the user, in both the desktop TV preview and the mobile popup — but\n   an ease-out with no overshoot, so it settles cleanly instead of bouncing. */\n.ia-anim-fade {\n    animation: ia-fade-in 0.6s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.ia-anim-pop {\n    animation: ia-pop-in 0.6s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n/* ---------- Generic modal (used for the mobile preview popup) ---------- */\n\n.ia-modal-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(15, 15, 20, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1050;\n    padding: 20px;\n}\n\n.ia-modal {\n    width: 100%;\n    max-width: 430px;\n    max-height: 90vh;\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    animation: ia-fade-in 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.ia-modal-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 20px;\n    border-bottom: 1px solid var(--ia-border);\n}\n\n.ia-modal-title {\n    font-size: 16px;\n    font-weight: 700;\n    margin: 0;\n}\n\n.ia-modal-close {\n    background: none;\n    border: none;\n    font-size: 18px;\n    color: var(--ia-muted);\n    cursor: pointer;\n    line-height: 1;\n}\n\n.ia-modal-body {\n    padding: 20px;\n    overflow-y: auto;\n}\n\n.ia-modal-body-center {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 420px;\n}\n\n/* Shoppable's product card: a square thumb on the left, a caption + CTA bar\n   stacked in a column on the right — styled after a typical shoppable-video\n   product overlay widget (thumb | name+expand / CTA bar), rather than the\n   thumb-with-caption-underneath chip this used to be. */\n.ia-product-chip {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: rgba(169, 155, 155, 0.6);\n    color: #111827;\n    border-radius: 10px;\n    padding: 6px;\n    width: 64px;\n    flex-shrink: 0;\n    text-align: left;\n}\n\n.ia-product-chip-thumb {\n    width: 76px;\n    height: 76px;\n    aspect-ratio: 1;\n    border-radius: 6px;\n    background: #fff;\n    object-fit: cover;\n    flex-shrink: 0;\n    box-shadow: none;\n    filter: none;\n}\n\n.ia-product-chip-info {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.ia-product-chip-title-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 4px;\n}\n\n.ia-product-chip-expand {\n    position: absolute;\n    top: 6px;\n    right: 6px;\n    font-size: 10px;\n    color: rgba(17, 24, 39, 0.55);\n    background: transparent;\n    flex-shrink: 0;\n}\n\n.ia-product-chip-caption {\n    font-size: 18px;\n    font-weight: 700;\n    color: #111827;\n    text-align: left;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-shadow: none;\n}\n\n.ia-product-chip-cta {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n    width: 130px;\n    padding: 7px 10px;\n    border-radius: 999px;\n    background: #FFD100;\n    color: #111827;\n    font-size: 12px;\n    font-weight: 700;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-family: 'Gilroy-SemiBold', 'Gilroy-Medium', 'Gilroy', sans-serif;\n}\n\n.ia-product-chip-cta i {\n    font-size: 11px;\n}\n\n/* Shoppable configure page's product panel (Horizontal Panel / Overlay / Side Panel) */\n.ia-preview-frame-phone .ia-product-chip {\n    width: 38px;\n    flex-shrink: 0;\n    padding: 0;\n}\n\n.ia-product-strip {\n    display: flex;\n    align-items: center;\n    gap: 0px;\n    overflow: hidden;\n}\n\n.ia-product-strip.grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n}\n\n.ia-product-strip .ia-product-chip {\n    width: 46px;\n    flex-shrink: 0;\n}\n\n.ia-product-strip.grid .ia-product-chip {\n    width: auto;\n}\n\n.ia-preview-shop-btn-small {\n    width: 100%;\n    padding: 6px 10px;\n    border: none;\n    border-radius: 999px;\n    background: var(--ia-primary);\n    color: #fff;\n    font-size: 10px;\n    font-weight: 700;\n    font-family: 'Gilroy-SemiBold', 'Gilroy-Medium', 'Gilroy', sans-serif;\n    cursor: default;\n}\n\n/* Horizontal Panel layout: full-width bar in the frame's reserved bottom strip\n   (--ia-bottom-h, shrunk out of the video viewport above), so it sits below\n   the creative instead of over it. The strip is centered rather than\n   left-aligned so it doesn't leave a stretch of empty bar to the right of a\n   short (carousel) row of chips. Bottom corners match the frame's own radius\n   since this bar is flush against the frame's real bottom edge. */\n.ia-product-panel-horizontal {\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: var(--ia-bottom-h);\n    background: rgba(0, 0, 0, 0.15);\n    padding: 3px 14px;\n    box-sizing: border-box;\n    border-radius: 0 0 8px 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.ia-product-panel-horizontal .ia-product-strip.grid {\n    grid-template-columns: repeat(4, 1fr);\n}\n\n/* Chip size synced across all three layouts — using Overlay's size as the\n   shared reference for Horizontal Panel and Side Panel too. */\n.ia-product-panel-horizontal .ia-product-strip .ia-product-chip {\n    width: 62px;\n}\n\n/* Neither panel needs the generic .ia-overlay-decoration \"rise with a glow\"\n   drop-shadow (that's meant for the QR badge floating over the video) — the\n   product panel already has its own translucent background, so the added\n   shadow just looked like an unwanted halo behind the small chip images. */\n.ia-product-panel-horizontal.ia-overlay-decoration.visible,\n.ia-product-panel-overlay.ia-overlay-decoration.visible {\n    box-shadow: none;\n}\n\n/* Overlay layout: compact panel floats over the ad, anchored to Footer (center) / Left / Right.\n   Sized to hug the chip exactly like Side Panel does (--ia-badge-w == chip\n   width, no outer padding) instead of leaving the chip floating inside a\n   wider fixed-width badge — that gap was the extra white space. */\n.ia-product-panel-overlay {\n    --ia-badge-w: 62px;\n    width: var(--ia-badge-w);\n    bottom: 20px;\n    background: rgba(255, 255, 255, 0.6);\n    border-radius: 6px;\n    padding: 0;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.ia-product-panel-overlay .ia-product-strip {\n    width: 100%;\n}\n\n.ia-product-panel-overlay .ia-product-strip .ia-product-chip {\n    width: 62px;\n}\n\n.ia-product-panel-overlay.ia-pp-left { left: 20px; }\n.ia-product-panel-overlay.ia-pp-right { left: calc(100% - var(--ia-badge-w) - 20px); }\n.ia-product-panel-overlay.ia-pp-footer { left: calc(50% - var(--ia-badge-w) / 2); }\n\n.ia-product-panel-side .ia-product-strip {\n    flex-direction: column;\n}\n\n.ia-product-panel-side .ia-product-strip .ia-product-chip {\n    width: 62px;\n}\n\n/* Scaled-down sizing when rendered inside the narrow mobile frame */\n.ia-preview-frame-phone .ia-product-panel-horizontal .ia-product-strip .ia-product-chip {\n    width: 38px;\n}\n\n.ia-preview-frame-phone .ia-product-panel-overlay {\n    --ia-badge-w: 225px;\n    height: 80px;\n    padding: 0;\n}\n\n.ia-preview-frame-phone .ia-product-panel-overlay .ia-product-strip .ia-product-chip {\n    width: 100%;\n}\n\n.ia-preview-frame-phone .ia-product-panel-side .ia-product-strip .ia-product-chip {\n    width: 38px;\n}\n\n.ia-format-desc {\n    color: var(--ia-muted);\n    font-size: 13px;\n    margin: 14px 0 12px;\n}\n\n.ia-supported-on-label {\n    font-size: 12px;\n    font-weight: 700;\n    color: var(--ia-text);\n    margin-bottom: 8px;\n    display: block;\n    font-family: 'Gilroy-Bold', 'Gilroy', sans-serif;\n}\n\n.ia-supported-on-row {\n    display: flex;\n    gap: 16px;\n    margin-bottom: 16px;\n}\n\n.ia-supported-chip {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    color: var(--ia-muted);\n    font-family: 'Gilroy-Medium', 'Gilroy', sans-serif;\n}\n\n.ia-configure-btn {\n    width: 100%;\n    justify-content: center;\n    margin-top: auto;\n}\n\n.ia-configure-btn-row {\n    display: flex;\n    gap: 10px;\n    margin-top: auto;\n}\n\n.ia-configure-btn-row .ia-configure-btn {\n    margin-top: 0;\n}\n\n/* ---------- Value strip ---------- */\n\n.ia-value-strip {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n    gap: 20px;\n    border: 1px solid var(--ia-border);\n    border-radius: 12px;\n    padding: 20px;\n    margin-top: 32px;\n}\n\n.ia-value-item {\n    display: flex;\n    gap: 12px;\n}\n\n.ia-value-icon {\n    color: var(--ia-primary);\n    font-size: 20px;\n    flex-shrink: 0;\n    margin-top: 2px;\n}\n\n.ia-value-title {\n    font-size: 13px;\n    font-weight: 700;\n    color: var(--ia-primary);\n    margin: 0 0 2px;\n}\n\n.ia-value-desc {\n    font-size: 12px;\n    color: var(--ia-muted);\n    margin: 0;\n}\n\n/* ---------- Configure pages ---------- */\n\n.ia-back-link {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    color: var(--ia-muted);\n    font-size: 13px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 0;\n    margin-bottom: 14px;\n}\n\n.ia-back-link:hover {\n    color: var(--ia-text);\n}\n\n.ia-configure-grid {\n    display: grid;\n    grid-template-columns: minmax(320px, 420px) 1fr;\n    gap: 20px;\n    align-items: start;\n    margin-top: 20px;\n}\n\n@media (max-width: 900px) {\n    .ia-configure-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n.ia-panel {\n    background: #fff;\n    border: 1px solid var(--ia-border);\n    border-radius: 12px;\n    padding: 20px;\n}\n\n.ia-panel-title {\n    font-size: 15px;\n    font-weight: 700;\n    margin: 0 0 16px;\n}\n\n.ia-field-label {\n    display: block;\n    font-size: 13px;\n    font-weight: 700;\n    color: var(--ia-text);\n    margin-bottom: 8px;\n}\n\n.ia-required {\n    color: #dc2626;\n}\n\n.ia-field-input {\n    width: 100%;\n    padding: 10px 12px;\n    border: 1px solid var(--ia-border);\n    border-radius: 6px;\n    font-size: 14px;\n    box-sizing: border-box;\n    margin-bottom: 16px;\n}\n\n.ia-field-input:focus {\n    outline: none;\n    border-color: var(--ia-primary);\n}\n\n.ia-input-icon-wrap {\n    position: relative;\n    margin-bottom: 16px;\n}\n\n.ia-input-icon-wrap .ia-field-input {\n    margin-bottom: 0;\n    padding-right: 36px;\n}\n\n.ia-input-icon-wrap i {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: var(--ia-muted);\n    font-size: 13px;\n}\n\n.ia-select {\n    width: 100%;\n    padding: 10px 12px;\n    border: 1px solid var(--ia-border);\n    border-radius: 6px;\n    font-size: 14px;\n    background: #fff;\n    box-sizing: border-box;\n    margin-bottom: 16px;\n}\n\n.ia-divider {\n    height: 1px;\n    background: var(--ia-border);\n    margin: 4px 0 16px;\n}\n\n.ia-toggle-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 4px;\n}\n\n.ia-toggle-text {\n    font-size: 13px;\n    font-weight: 700;\n}\n\n.ia-toggle-help {\n    font-size: 12px;\n    color: var(--ia-muted);\n    margin: 4px 0 16px;\n}\n\n.ia-switch {\n    width: 38px;\n    height: 22px;\n    border-radius: 999px;\n    background: #d1d5db;\n    border: none;\n    position: relative;\n    cursor: pointer;\n    flex-shrink: 0;\n    padding: 0;\n    transition: background 0.15s ease;\n}\n\n.ia-switch.on {\n    background: var(--ia-primary);\n}\n\n.ia-switch-knob {\n    position: absolute;\n    top: 3px;\n    left: 3px;\n    width: 16px;\n    height: 16px;\n    background: #fff;\n    border-radius: 50%;\n    transition: transform 0.15s ease;\n}\n\n.ia-switch.on .ia-switch-knob {\n    transform: translateX(16px);\n}\n\n.ia-radio-group {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-bottom: 16px;\n}\n\n.ia-radio-option {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    cursor: pointer;\n}\n\n.ia-radio-option input {\n    accent-color: var(--ia-primary);\n    width: 15px;\n    height: 15px;\n    cursor: pointer;\n}\n\n.ia-file-chip {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    border: 1px solid var(--ia-border);\n    border-radius: 8px;\n    padding: 10px 12px;\n    margin-bottom: 16px;\n}\n\n.ia-file-chip i.ia-file-icon {\n    color: var(--ia-green);\n    font-size: 18px;\n}\n\n.ia-file-chip-info {\n    flex: 1;\n    min-width: 0;\n}\n\n.ia-file-chip-name {\n    font-size: 13px;\n    font-weight: 600;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.ia-file-chip-size {\n    font-size: 11px;\n    color: var(--ia-muted);\n}\n\n.ia-file-chip i.ia-file-check {\n    color: #16a34a;\n}\n\n.ia-file-chip-change {\n    background: none;\n    border: none;\n    color: var(--ia-primary);\n    font-size: 12px;\n    font-weight: 700;\n    cursor: pointer;\n    padding: 0;\n    white-space: nowrap;\n}\n\n.ia-file-picker-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 16px;\n    border: 1px dashed var(--ia-border);\n    border-radius: 8px;\n    background: #fafafa;\n    color: var(--ia-text);\n    font-size: 13px;\n    cursor: pointer;\n    margin-bottom: 16px;\n}\n\n.ia-panel-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    margin-top: 8px;\n}\n\n/* ---------- Preview panel ---------- */\n\n.ia-preview-wrap {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.ia-preview-frame-tv {\n    width: 100%;\n    max-width: 760px;\n    background: #111827;\n    border-radius: 14px;\n    padding: 16px;\n    box-sizing: border-box;\n}\n\n.ia-preview-tv-stand {\n    position: relative;\n    width: 130px;\n    height: 10px;\n    background: #111827;\n    margin: 0 auto;\n    border-radius: 0 0 6px 6px;\n}\n\n.ia-preview-tv-stand::after {\n    content: '';\n    position: relative;\n    display: block;\n    width: 190px;\n    height: 5px;\n    background: #111827;\n    margin: 0 auto;\n    border-radius: 4px;\n    transform: translateX(-50%) translateY(10px);\n    left: 50%;\n}\n\n/* Scaled-up sizing for the same ad-mock components when they render inside the\n   larger desktop TV preview, so the frame doesn't look mostly empty. */\n.ia-preview-frame-tv .ia-ad-mock-qr {\n    /* --ia-badge-w: 112px; */\n    /* padding: 12px; */\n}\n\n.ia-preview-frame-tv .ia-ad-mock-qr i {\n    font-size: 48px;\n}\n\n.ia-preview-frame-tv .ia-ad-mock-qr span {\n    font-size: 10px;\n    margin-top: 6px;\n}\n\n.ia-preview-frame-tv .ia-video-frame {\n    --ia-panel-w: 160px;\n    --ia-bottom-h: 76px;\n}\n\n.ia-preview-frame-tv .ia-qr-frame {\n    --ia-panel-w: 120px;\n}\n\n/* Shoppable's desktop/TV preview shows a vertical (9:16) mobile-style ad\n   instead of a 16:9 landscape frame, since the creative is consumed as a\n   vertical story/reel-style video — sized by height and centered in the\n   wide TV card instead of stretching full-width. object-fit:cover fills\n   that vertical frame edge-to-edge from the 16:9 source (cropping the\n   sides). Panel sizing below is scaled down to match this narrower frame,\n   reusing roughly the same proportions as the phone preview. */\n.ia-preview-frame-tv .ia-shoppable-frame {\n    --ia-panel-w: 90px;\n    --ia-bottom-h: 90px;\n    width: auto;\n    height: 520px;\n    aspect-ratio: 9 / 16;\n    margin: 0 auto;\n}\n\n.ia-preview-frame-tv .ia-shoppable-frame .ia-ad-mock-media {\n    object-fit: cover;\n}\n\n/* Side Panel on the TV/desktop preview: match the mobile preview exactly —\n   the video switches to object-fit:contain so it visibly shrinks to fit the\n   narrower area freed up for the panel, instead of staying cover-cropped\n   (which just loses the video's edge and doesn't read as \"shifting\" at all). */\n.ia-preview-frame-tv .ia-shoppable-frame.panel-left .ia-ad-mock-media,\n.ia-preview-frame-tv .ia-shoppable-frame.panel-right .ia-ad-mock-media {\n    object-fit: contain;\n}\n\n.ia-preview-frame-tv .ia-shoppable-frame .ia-product-panel-side .ia-product-strip .ia-product-chip {\n    width: 44px;\n}\n\n.ia-preview-frame-tv .ia-shoppable-frame .ia-product-panel-horizontal .ia-product-strip .ia-product-chip {\n    width: 44px;\n}\n\n.ia-preview-frame-tv .ia-shoppable-frame .ia-product-panel-overlay {\n    --ia-badge-w: 44px;\n    padding: 0;\n}\n\n.ia-preview-frame-tv .ia-shoppable-frame .ia-product-panel-overlay .ia-product-strip .ia-product-chip {\n    width: 44px;\n}\n\n.ia-preview-frame-tv .ia-qr-sidepanel-inner,\n.ia-preview-frame-tv .ia-product-panel-side-inner {\n    padding: 16px;\n    gap: 12px;\n}\n\n.ia-preview-frame-tv .ia-qr-sidepanel-inner i {\n    font-size: 44px;\n}\n\n.ia-preview-frame-tv .ia-qr-sidepanel-inner span {\n    font-size: 12px;\n}\n\n.ia-preview-frame-tv .ia-product-panel-side .ia-product-strip .ia-product-chip {\n    width: 84px;\n}\n\n.ia-preview-frame-tv .ia-product-panel-horizontal {\n    padding: 3px 0px;\n    padding-bottom: 0px;\n}\n\n.ia-preview-frame-tv .ia-product-panel-horizontal .ia-product-strip .ia-product-chip {\n    width: 56px;\n}\n\n.ia-preview-frame-tv .ia-product-panel-overlay {\n    --ia-badge-w: 84px;\n    padding: 0;\n}\n\n.ia-preview-frame-tv .ia-product-panel-overlay .ia-product-strip .ia-product-chip {\n    width: 84px;\n}\n\n.ia-preview-frame-tv .ia-preview-shop-btn-small {\n    font-size: 13px;\n    padding: 10px;\n}\n\n/* Sized to a real phone's ~19.5:9 screen ratio (not just tall enough to wrap\n   the status bar + ad) so the mockup reads as an actual phone. The ad itself\n   still only occupies its native 16:9 height at the top; ia-preview-phone-fill\n   soaks up the remaining height like the rest of a phone's screen, and the\n   home indicator caps it off flush with the bottom corner radius instead of\n   leaving the ad's own corner sitting awkwardly close to the bezel curve. */\n.ia-preview-frame-phone {\n    width: 260px;\n    aspect-ratio: 9 / 19.5;\n    background: #111827;\n    border-radius: 28px;\n    padding: 10px;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n}\n\n.ia-preview-phone-statusbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-shrink: 0;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 700;\n    padding: 4px 8px 8px;\n}\n\n.ia-preview-phone-statusbar .icons {\n    display: flex;\n    gap: 5px;\n    font-size: 10px;\n}\n\n/* Soaks up whatever height a fixed-aspect ad (the QR frame's 9/16 box) leaves\n   behind, so the rest of the phone body reads as empty chrome below the ad\n   instead of the ad being stretched to fill it. No-op for formats whose frame\n   already fills the full remaining height (flex:1 there leaves nothing for\n   this to absorb). */\n.ia-preview-phone-fill {\n    display: block;\n    flex: 1;\n    min-height: 0;\n}\n\n.ia-preview-frame-phone .ia-video-frame {\n    --ia-bottom-h: 58px;\n    flex: 1;\n    margin-top: 0;\n    min-height: 0;\n}\n\n/* Mobile preview (QR and Shoppable both): the video fills the entire phone\n   screen edge-to-edge (a true full-screen 9:16 vertical ad unit) instead of\n   sitting in a boxed area with empty phone chrome around it. The status bar\n   and home indicator float on top of the video (absolutely positioned)\n   rather than sharing flow space with it, so the ad still reads as \"full\n   screen\" underneath them — all existing features (QR badge/overlay, product\n   panels, side panel) keep working since they're still rendered inside the\n   same frame, just now stretched to fill the whole device instead of a\n   smaller boxed area. Scoped to .ia-video-frame generically so both QR's\n   .ia-qr-frame and Shoppable's .ia-shoppable-frame get identical treatment. */\n.ia-preview-frame-phone.ia-preview-frame-phone-fullbleed {\n    position: relative;\n    aspect-ratio: 9 / 16;\n    padding: 0;\n    overflow: hidden;\n}\n\n.ia-preview-frame-phone-fullbleed .ia-preview-phone-statusbar {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 2;\n    padding: 14px 18px 8px;\n    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0));\n}\n\n.ia-preview-frame-phone-fullbleed .ia-video-frame {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    aspect-ratio: auto;\n    max-height: none;\n    margin-top: 0;\n    border-radius: 0;\n}\n\n.ia-preview-frame-phone-fullbleed .ia-video-frame .ia-ad-mock-media {\n    object-fit: cover;\n}\n\n/* Display's banner fills the frame the same way OLV's video does — cover,\n   scaling to fill edge-to-edge and cropping any aspect-ratio overflow —\n   rather than stretching, so it always looks proportionally correct. */\n.ia-preview-frame-phone-fullbleed .ia-video-frame.ia-format-display .ia-ad-mock-media {\n    object-fit: cover;\n}\n\n/* Side Panel: match desktop's behavior exactly — the viewport shrinks width\n   (via panel-left/panel-right + --ia-panel-w, same mechanism as desktop) and\n   the video switches to object-fit:contain so it visibly shrinks to fit the\n   narrower area, instead of staying cover-cropped and just losing its edge\n   (which wouldn't read as \"shrinking\" at all). */\n.ia-preview-frame-phone-fullbleed .ia-video-frame.panel-left .ia-ad-mock-media,\n.ia-preview-frame-phone-fullbleed .ia-video-frame.panel-right .ia-ad-mock-media {\n    object-fit: contain;\n}\n\n/* Display (static banner) falls back to the same object-fit:contain as OLV's\n   video in Side Panel — the creative must never be cropped, so on Side Panel\n   specifically it's shown fully (letterboxed if needed) rather than covering\n   and cutting off part of the image. */\n\n.ia-preview-frame-phone-fullbleed .ia-preview-phone-home-indicator {\n    position: absolute;\n    bottom: 10px;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 2;\n    margin: 0;\n}\n\n/* Shoppable's mobile ad, like the QR frame, plays as a true 9:16 box sized\n   off the frame's own width — instead of stretching to fill whatever's left\n   of the phone body. object-fit:contain keeps the full 16:9 source visible\n   (letterboxed above/below) rather than cropping its sides. Excludes the QR\n   frame, which keeps its own native 16:9 box. */\n.ia-preview-frame-phone .ia-video-frame:not(.ia-qr-frame):not(.ia-format-display) {\n    flex: 0 0 auto;\n    width: 100%;\n    height: auto;\n    aspect-ratio: 9 / 16;\n    max-height: 100%;\n}\n\n.ia-preview-frame-phone .ia-video-frame:not(.ia-qr-frame):not(.ia-format-display) .ia-ad-mock-media {\n    object-fit: contain;\n}\n\n.ia-preview-phone-home-indicator {\n    flex-shrink: 0;\n    align-self: center;\n    width: 90px;\n    height: 4px;\n    border-radius: 999px;\n    background: rgba(255, 255, 255, 0.6);\n    margin: 10px 0 2px;\n}\n\n.ia-simulated-note {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 11px;\n    color: var(--ia-muted);\n    margin-top: 12px;\n    font-style: italic;\n}\n\n/* ---------- \"Generate Demo On Web Page\" — a generic publisher page mockup\n   with the ad creative dropped into its ad slot, centered, for a realistic\n   in-context preview instead of just the bare mobile frame. ---------- */\n\n.ia-webdemo-modal {\n    position: relative;\n    width: 100%;\n    max-width: 1040px;\n    max-height: 92vh;\n    overflow-y: auto;\n    background: #0b0d10;\n    border-radius: 12px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);\n}\n\n.ia-webdemo-close {\n    position: sticky;\n    top: 12px;\n    left: 100%;\n    margin-right: 12px;\n    z-index: 5;\n    color: #fff;\n    background: rgba(255, 255, 255, 0.12);\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.ia-webdemo-site {\n    color: #e5e7eb;\n    padding: 0 0 24px;\n    font-family: 'Gilroy-Medium', 'Gilroy', sans-serif;\n}\n\n/* The background image's own yellow rectangle marks exactly where the ad\n   should sit — sized to the image's native ratio so the ad-slot's percentage\n   position below always lines up with that marker regardless of the\n   modal's actual rendered width. */\n.ia-webdemo-site-bg {\n    position: relative;\n    width: 100%;\n    max-width: 100%;\n    margin: 0 auto;\n    aspect-ratio: 2025 / 1494;\n    background-image: none;\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n    padding: 0;\n}\n\n.ia-webdemo-nav {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 14px 24px;\n    background: #000;\n    flex-wrap: wrap;\n}\n\n.ia-webdemo-logo {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-weight: 800;\n    font-size: 16px;\n    color: #fff;\n    letter-spacing: 0.02em;\n}\n\n.ia-webdemo-nav-links {\n    display: flex;\n    gap: 20px;\n    font-size: 13px;\n    font-weight: 700;\n    color: #d1d5db;\n    flex-wrap: wrap;\n}\n\n.ia-webdemo-login {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 13px;\n    font-weight: 700;\n    color: #fff;\n    white-space: nowrap;\n}\n\n.ia-webdemo-ad-label {\n    text-align: center;\n    font-size: 11px;\n    color: #9ca3af;\n    margin: 16px 0 8px;\n}\n\n.ia-webdemo-ad-slot {\n    position: absolute;\n    left: 51.5%;\n    top: 23.4%;\n    transform: translate(-50%, -50%);\n    width: min(480px, 90%);\n    aspect-ratio: 16 / 9;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 6px;\n    overflow: hidden;\n}\n\n/* The shoppable overlay card sits on top of the ad creative, bottom-center,\n   same as it would in the real Overlay layout — reuses .ia-product-chip so\n   sizing/colors stay in sync with the mobile preview automatically. */\n.ia-webdemo-ad-overlay {\n    position: absolute;\n    left: 50%;\n    bottom: 16px;\n    width: 200px;\n    z-index: 2;\n}\n\n/* .ia-overlay-decoration sets its own `transform` for the fade/scale reveal,\n   which would otherwise wipe out the translateX(-50%) centering above — so\n   both are combined into one transform value here, scoped specifically to\n   this element. */\n.ia-webdemo-ad-overlay.ia-overlay-decoration {\n    transform: translateX(-50%) scale(0.9) translateY(14px);\n}\n\n.ia-webdemo-ad-overlay.ia-overlay-decoration.visible {\n    transform: translateX(-50%) scale(1) translateY(0);\n}\n\n.ia-webdemo-ad-overlay .ia-product-chip {\n    width: 100%;\n}\n\n.ia-webdemo-ad-overlay .ia-product-chip-cta {\n    width: 100px;\n}\n\n.ia-webdemo-ad-media {\n    width: 100%;\n    height: 90%;\n    object-fit: contain;\n    display: block;\n    margin: 0 auto;\n}\n\n.ia-webdemo-scores-bar {\n    display: flex;\n    gap: 10px;\n    padding: 20px 24px 12px;\n    flex-wrap: wrap;\n}\n\n.ia-webdemo-scores-tab {\n    padding: 6px 14px;\n    border-radius: 999px;\n    background: #1c2128;\n    font-size: 12px;\n    font-weight: 700;\n    color: #d1d5db;\n}\n\n.ia-webdemo-scores-tab.active {\n    background: #fff;\n    color: #111827;\n}\n\n.ia-webdemo-score-cards {\n    display: flex;\n    gap: 12px;\n    padding: 0 24px 20px;\n    flex-wrap: wrap;\n}\n\n.ia-webdemo-score-card {\n    flex: 1;\n    min-width: 200px;\n    background: #14181d;\n    border-radius: 8px;\n    padding: 12px;\n}\n\n.ia-webdemo-score-comp {\n    font-size: 11px;\n    color: #9ca3af;\n    margin-bottom: 8px;\n}\n\n.ia-webdemo-score-row {\n    display: flex;\n    justify-content: space-between;\n    font-size: 13px;\n    font-weight: 700;\n    padding: 4px 0;\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.ia-webdemo-score-row:first-of-type {\n    border-top: none;\n}\n\n.ia-webdemo-tiles {\n    display: flex;\n    gap: 12px;\n    padding: 0 24px;\n    flex-wrap: wrap;\n}\n\n.ia-webdemo-tile {\n    flex: 1;\n    min-width: 200px;\n    background: #14181d;\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.ia-webdemo-tile-wide {\n    flex: 2;\n}\n\n.ia-webdemo-tile-thumb {\n    width: 100%;\n    aspect-ratio: 16 / 9;\n    background: linear-gradient(135deg, #1f2937, #374151);\n}\n\n.ia-webdemo-tile p {\n    margin: 0;\n    padding: 10px 12px;\n    font-size: 12px;\n    color: #d1d5db;\n}\n\n.ia-webdemo-note {\n    padding: 0 24px 20px;\n    color: #9ca3af;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
